import { render, staticRenderFns } from "./TableTag.vue?vue&type=template&id=6a800e5f&"
import script from "./TableTag.vue?vue&type=script&lang=js&"
export * from "./TableTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports